<template>
  <div>
    <div  v-if="isScrolled9">
      <Header/>
    </div>
    <div style="height: 5em;"></div>
    <div class="Breadcrumbs">
      <div class="box">
        <a href='/' class=''>{{ $t('message.contactBreadcrumbHome') }}</a> &gt; <a>{{ $t('message.contactBreadcrumbService') }}</a> &gt; <a>{{ $t('message.contactBreadcrumbContact') }}</a>
      </div>
    </div>

    <!-- 联系我们 -->
    <div class="contact">
      <div class="box">

        <div  class="cbox1">
<!--          客服咨询-->

          <!--        50px用于动画向上移动的距离-->
          <div style="margin-top: 50px" class="item wow fadeInUp move1">
            <div class="icon"><img :src="require('@/assets/newImage/1-21050G9434Q51.png')" alt=""></div>
            <div class="tbox">
              <h2 class="t1">{{ $t('message.customerService') }}</h2>
              <div class="t2">
                <p>{{ $t('message.customerServiceQQ') }}</p><br><br>
              </div>
              <!-- <a class="t3">{{ $t('message.contactCustomerService') }}</a> -->
            </div>
          </div>
<!--          商务合作-->
          <div class="item wow fadeInUp move1" >
            <div class="icon"><img :src="require('@/assets/newImage/icon48.png')" alt=""></div>
            <div class="tbox">
              <h2 class="t1">{{ $t('message.businessCooperation') }}</h2>
              <div class="t2">
                <p>{{ $t('message.businessCooperationDesc') }}</p>
              </div>
              <div class="t3">{{ $t('message.businessEmail') }}</div>
            </div>
          </div>

        </div>
        <form class="cbox2" @submit.prevent="submitForm">
          <h2 class="title">{{ $t('message.leaveMessage') }}</h2>
          <input type="text" class="txt t1" v-model="name" :placeholder="$t('message.yourName')" required>
          <input type="text" class="txt t2" v-model="contact" :placeholder="$t('message.contactInfo')" required>
          <input type="text" class="txt t3" v-model="email" :placeholder="$t('message.yourEmail')" required pattern="^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$" title="请输入正确的邮箱格式" />
          <textarea class="text" v-model="message" :placeholder="$t('message.messageContent')" required></textarea>
          <input type="submit" :value="$t('message.submit')" class="btn">
        </form>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from "@/views/header.vue";
import Banner from "../components/Banner";
import Footer from "@/views/footer.vue";

export default {
  components: {
    Header,
    Banner,
    Footer
  },
  data() {
    return {
      isScrolled9: true,
      name: '',
      contact: '',
      email: '',
      message: '',
      loading: true,
      caseList: []
    };
  },
  created() {
    document.title = this.$t('message.contactTitle') + '_智慧林';
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.handleScroll9);
    window.console.log("case");
    this.$http
        .get("Cases/GetCasesAll")
        .then(response => {
          //console.log(response);
          this.caseList = response.data;
          //window.console.log(this.caseList);
          this.loading = false;
        })
        .catch(function(error) {
          window.console.log(error);
        });
  },
  methods:{
    handleScroll9() {
      // 获取当前滚动位置
      const scrollY = window.scrollY || window.pageYOffset;

      // 可以设置一个阈值来确定何时改变isScrolled9的值
      const dis = 100;

      // 判断滚动位置是否大于阈值
      if (scrollY > dis) {
        // 向下滚动，将isScrolled9设为false
        this.isScrolled9 = false;
      } else {
        // 向上滚动，将isScrolled9设为true
        this.isScrolled9 = true;
      }
    },
    submitForm() {
      console.log("提交表单");

      if (this.name.trim() !== '' && this.contact.trim() !== '' && this.email.trim() !== '' && this.message.trim() !== '') {
        const headers = {
          'Authorization': '',
        };
        
        // 定义请求体
        const postData = {
          17: this.name,
          19: this.contact,
          21: this.email,
          23: this.message,
          typeid: 67,
        };
        
        // 发送 POST 请求
        this.$http.post('yasubit/guestbook/insert', postData, { headers })
          .then(response => {
            console.log("post成功");
            this.$message.success(this.$t('message.submitSuccess'));
            // 清空表单
            this.name = '';
            this.contact = '';
            this.email = '';
            this.message = '';
          })
          .catch(error => {
            console.error('Error fetching data:', error);
            this.$message.error(this.$t('message.submitFailed'));
          });
      } else {
        this.$message.warning(this.$t('message.completeInfo'));
      }
    }
  }
};
</script>

<style lang="scss" scoped>

.move1 {
  opacity: 0; // 初始时透明度为0，隐藏元素
  animation: fadeIn 1s forwards, moveUp 1.2s forwards; // 1s 表示动画持续时间，forwards 表示动画结束后保持最终状态
}


@keyframes moveUp {
  to {
    transform: translateY(-50px); // 向上移动 px
  }
}

@keyframes fadeIn {
  to {
    opacity: 1; // 最终透明度为1，显示元素
  }
}

#movingBox {
  transition: transform 0.5s ease; // 添加过渡效果
}

.bounce-animation {
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0); // 初始位置和结束位置
  }

  40% {
    transform: translateY(-15px); // 上抬的高度，可以根据需要修改
  }

  60% {
    transform: translateY(-15px); // 下压的高度，可以根据需要修改
  }
}


</style>